var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        "--link-color": "var(--theme-action-primary-dk)",
        "--link-hover-color": "var(--theme-action-primary)",
      },
      attrs: { id: "icon-pack-specs" },
    },
    [
      _c("h3", { staticClass: "sr-only" }, [
        _vm._v("About " + _vm._s(_vm.iconPack().label)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "display-flex flex-row flex-wrap flex-items-center flex-content-center laptop:flex-content-between",
          staticStyle: { gap: "var(--spacing-xl)" },
        },
        [
          _c(
            "dl",
            {
              staticClass:
                "icon-pack-metadata padding-0 margin-0 display-flex flex-row flex-wrap flex-items-center flex-content-between laptop:flex-content-start",
            },
            [
              _c("dt", { staticClass: "sr-only" }, [
                _vm._v("Icon Canvas Size"),
              ]),
              _vm._v(" "),
              _c(
                "dd",
                {
                  staticClass:
                    "icon-pack-metadata-item margin-bottom-0 text-nowrap",
                  on: {
                    mouseenter: function ($event) {
                      return _vm.handleToggle("Canvas")
                    },
                    mouseleave: function ($event) {
                      return _vm.handleToggle("Canvas")
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "margin-right-2xs",
                    attrs: { icon: _vm.$v6.solid.faFrame, "fixed-width": "" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "size-sm" }, [
                    _vm._v(
                      _vm._s(_vm.iconPack().sourceCanvasHeight) +
                        "px Canvas\n          "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("dt", { staticClass: "sr-only" }, [_vm._v("Icon Grid Size")]),
              _vm._v(" "),
              _c(
                "dd",
                {
                  staticClass:
                    "icon-pack-metadata-item margin-bottom-0 text-nowrap",
                  on: {
                    mouseenter: function ($event) {
                      return _vm.handleToggle("Grid")
                    },
                    mouseleave: function ($event) {
                      return _vm.handleToggle("Grid")
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "margin-right-2xs",
                    attrs: { icon: _vm.$v6.solid.faExpand, "fixed-width": "" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "size-sm" }, [
                    _vm._v(
                      _vm._s(_vm.iconPack().sourceGridHeight) +
                        "px Grid\n          "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isReleased()
                ? [
                    _c("dt", { staticClass: "sr-only" }, [
                      _vm._v("Total Icons"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "icon-pack-metadata-item margin-bottom-0 text-nowrap",
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-2xs",
                          attrs: {
                            icon: _vm.$v6.solid.faShapes,
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "size-sm" },
                          [
                            _c(
                              "site-link",
                              {
                                attrs: {
                                  to: _vm.$search({
                                    iconPacks: [_vm.iconPack().name],
                                  }),
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.$posthog.capture(
                                      "pack_landing:all_pack_icons_link_click, { pack: iconPack().name }"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.formattedTotalIconCount) + " Icons"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "sr-only" }, [
                      _vm._v("Total Styles"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "icon-pack-metadata-item margin-bottom-0 text-nowrap",
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-2xs",
                          attrs: {
                            icon: _vm.$v6.solid.faPalette,
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "size-sm" },
                          [
                            _c(
                              "site-link",
                              {
                                attrs: {
                                  to: _vm.$search({
                                    iconPacks: [_vm.iconPack().name],
                                  }),
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.$posthog.capture(
                                      "pack_landing:all_pack_styles_link_click, { pack: iconPack().name }"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.styleCount) +
                                    " " +
                                    _vm._s(_vm.styleCountLabel)
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "sr-only" }, [
                      _vm._v("Last Updated"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "icon-pack-metadata-item margin-bottom-0 text-nowrap",
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "margin-right-2xs",
                          attrs: {
                            icon: _vm.$v6.solid.faArrowsRotate,
                            "fixed-width": "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "size-sm" },
                          [
                            _vm._v("Updated in "),
                            _c(
                              "site-link",
                              { attrs: { to: { name: "changelog" } } },
                              [_vm._v(_vm._s(_vm.packLastUpdatedVersion))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "dl",
            { staticClass: "margin-0 padding-0 text-center laptop:text-right" },
            [
              _c("dt", { staticClass: "sr-only" }, [_vm._v("Creator(s)")]),
              _vm._v(" "),
              _c(
                "dd",
                { staticClass: "margin-bottom-0 text-nowrap" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "margin-right-2xs",
                    attrs: {
                      icon: _vm.$v6.solid.faSignature,
                      "fixed-width": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "size-sm" }, [
                    _vm._v("Designed by\n          "),
                    _vm.iconPack().url
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.iconPack().url,
                              target: "_blank",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.selectDesignerLink()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.iconPack().designer) + "\n          "
                            ),
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.iconPack().designer) +
                              "\n          "
                          ),
                        ]),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }